<div
  class="flex items-center justify-center min-h-[calc(100vh-4rem)] bg-white px-4"
>
  <div class="relative w-full max-w-[400px] border border-dc-navy mt-10">
    @if (!isSuccess) {
      <div class="form-card px-6 xl:!pr-6 xl:!pl-6">
        <div class="mx-auto w-full max-w-lg">
          <h1 class="text-3xl font-bold text-center text-dc-navy mb-8">
            {{ "RESET_PASSWORD_TITLE" | translate }}
          </h1>

          <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()">
            <div class="field-control">
              <label class="field-label font-bold">
                {{ "RESET_PASSWORD_NEW_PASSWORD" | translate }}
              </label>
              <app-text-field
                [label]="''"
                [hideLabel]="true"
                [control]="resetPasswordForm.get('newPassword')!"
                [type]="'password'"
                [maxlength]="120"
                 [showPasswordToggle]="true"
              ></app-text-field>
              <!-- [otherInfo]="'VALIDATION_MSG.PASSWORD_RULES' | translate" -->
            </div>

            <div class="field-control">
              <label class="field-label font-bold">
                {{ "RESET_PASSWORD_CONFIRM_NEW_PASSWORD" | translate }}
              </label>
              <app-text-field
                [label]="''"
                [hideLabel]="true"
                [control]="resetPasswordForm.get('confirmNewPassword')!"
                [type]="'password'"
                [maxlength]="120"
                 [showPasswordToggle]="true"
              ></app-text-field>
            </div>

            <div class="field-control">
              @if (errorCodeMsg) {
                <div class="mb-6">
                  <app-validation-message
                    [type]="'error'"
                    [content]="{
                      title: '',
                      message: errorCodeMsg | translate,
                    }"
                    [showbutton]="false"
                  ></app-validation-message>
                </div>
              }

              <app-button
                type="submit"
                classesName="btn-primary-big w-full"
                class="block w-full"
                [label]="'RESET_PASSWORD_PROCEED' | translate"
                [disabled]="isSubmitting"
              ></app-button>
            </div>
          </form>
        </div>
      </div>
    } @else {
      <div class="form-card px-6 xl:!pr-6 xl:!pl-6">
        <div class="mx-auto w-full max-w-lg text-center text-dc-navy">
          <h1 class="text-3xl font-bold mb-8">
            {{ "RESET_PASSWORD_SUCCESS_TITLE" | translate }}
          </h1>
          <p class="text-base! mb-8! text-dc-navy!">
            {{ "RESET_PASSWORD_SUCCESS_DESCRIPTION" | translate }}
          </p>
          <app-button
            type="button"
            classesName="btn-primary-big w-full"
            class="block w-full"
            [label]="'RESET_PASSWORD_BACK_TO_LOGIN' | translate"
            (onBtnClick)="backToLogin()"
          ></app-button>
        </div>
      </div>
    }
  </div>
</div>
